import { FormsModule, ReactiveFormsModule, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { NbInputModule, NbSelectModule, NbTooltipModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { KPI } from '../../../@core/api';

export interface DisplayedPerimeterReferenceValue extends Partial<KPI.PerimeterReferenceValue> {
  tooltip?: string;
  disabled: boolean;
  fieldObject?: KPI.ReferenceField;
}

@Component({
  selector: 'app-ref-data-input',
  standalone: true,
  imports: [
    NbTooltipModule, TranslateModule, FormsModule, ReactiveFormsModule, NbInputModule, NbSelectModule
  ],
  templateUrl: './ref-data-input.component.html',
  styleUrl: './ref-data-input.component.scss',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: RefDataInputComponent
  }],
})
export class RefDataInputComponent implements ControlValueAccessor, OnInit {

  @Input() refData: DisplayedPerimeterReferenceValue;

  public value!: string | number;
  public type: 'text' | 'number' | 'select' = 'text';
  public options: { id: number, label: string }[] = [];
  public disabled!: boolean;
  constructor() {}

  public ngOnInit(): void {
    this.value = this.refData.value;
    switch (this.refData.fieldObject?.data_type) {
      case KPI.ReferenceFieldDataType.DATA_TYPE_NUMBER:
        this.type = 'number';
        break;
      case KPI.ReferenceFieldDataType.DATA_TYPE_STRING:
        this.type = 'text';
        break;
      case KPI.ReferenceFieldDataType.DATA_TYPE_FK:
      case KPI.ReferenceFieldDataType.DATA_TYPE_USER:
        this.type = 'select';
        this.options = this.refData.fieldObject?.values || [];
        break;
      default:
        this.type = 'text';
        break;
    }
  }

  public valueChanged(value: string | number) {
    this.setValue(value, true);
  }

  public onChange: (value: string | number) => void;

  public onTouched: () => void;

  public writeValue(value: string | number): void {
    this.setValue(value, false);
  }

  public registerOnChange(fn: (value: string | number) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  protected setValue(value: string | number, emitEvent: boolean) {
    this.value = value;
    if (emitEvent && this.onChange) {
      this.onChange(value);
      this.onTouched();
    }
  }

}
